export const GET_CONNECTED_ACCOUNT = '[Stripe Connect] Get Connect Account';
export const GET_CONNECTED_ACCOUNT_SUCCESS =
  '[Stripe Connect] Get Connect Account Success';
export const GET_CONNECTED_ACCOUNT_ERROR =
  '[Stripe Connect] Get Connect Account Error';

export const CREATE_CONNECTED_ACCOUNT =
  '[Stripe Connect] Create Connected Account';
export const CREATE_CONNECTED_ACCOUNT_SUCCESS =
  '[Stripe Connect] Create Connected Account Success';
export const CREATE_CONNECTED_ACCOUNT_ERROR =
  '[Stripe Connect] Create Connected Account Error';

export const CREATE_ONBOARDING_LINK = '[Stripe Connect] Create Onboarding Link';
export const CREATE_ONBOARDING_LINK_SUCCESS =
  '[Stripe Connect] Create Onboarding Link Success';
export const CREATE_ONBOARDING_LINK_ERROR =
  '[Stripe Connect] Create Onboarding Link Error';

export const CREATE_LOGIN_LINK = '[Stripe Connect] Create Login Link';
export const CREATE_LOGIN_LINK_SUCCESS =
  '[Stripe Connect] Create Login Link Success';
export const CREATE_LOGIN_LINK_ERROR =
  '[Stripe Connect] Create Login Link Error';

export const CREATE_TRANSFER = '[Stripe Connect] Create Transfer';
export const CREATE_TRANSFER_SUCCESS =
  '[Stripe Connect] Create Transfer Success';
export const CREATE_TRANSFER_ERROR = '[Stripe Connect] Create Transfer Error';
